export default {
  返回顶部: '返回顶部',
  开拓市场寻觅商机: '开拓市场 寻觅商机',
  进入领券: '进入领券',
  企业员工列表: '企业员工列表',
  立即洽谈: '立即洽谈',
  '确定发送此图片吗?': '确定发送此图片吗?',
  采购金额: '采购金额',
  邀约客户: '邀约客户',
  优惠券总额: '优惠券总额',
  观展人次: '观展人次',
  招标总额: '招标总额',
  直播视频: '直播视频',
  暂无观看: '暂无观看',
  获取Ta的名片: '获取Ta的云展',
  企业实景3D: '企业实景3D',
  展览3D: '展览3D',
}
